import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  productImage: PropTypes.node.isRequired,
  productName: PropTypes.element.isRequired,
  productPrice: PropTypes.node,
  badge: PropTypes.element,
  closeButton: PropTypes.element,
  footer: PropTypes.node,
  variant: PropTypes.oneOf(['bordered', 'boxed'])
};
function ProductCard(_ref) {
  var badge = _ref.badge,
    children = _ref.children,
    closeButton = _ref.closeButton,
    footer = _ref.footer,
    header = _ref.header,
    productImage = _ref.productImage,
    productName = _ref.productName,
    productPrice = _ref.productPrice,
    variant = _ref.variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "productcard",
    "data-testid": "productcard",
    "data-badge": !!badge,
    "data-footer": !!footer,
    "data-variant": variant
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "productcard-badge"
  }, badge), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", {
    className: "productcard-Image"
  }, productImage), /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-content",
    "data-testid": "productcard-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-header",
    "data-testid": "productcard-header"
  }, header, closeButton && /*#__PURE__*/React__default.createElement("div", {
    className: "close",
    "data-testid": "close-button"
  }, closeButton), productName), /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-description",
    "data-testid": "productcard-description"
  }, children), /*#__PURE__*/React__default.createElement("span", {
    className: "productcard-price",
    "data-testid": "productcard-price"
  }, productPrice)), footer ? /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-footer",
    "data-testid": "productfooter"
  }, footer) : null);
}
ProductCard.propTypes = propTypes;

export { ProductCard as default };
//# sourceMappingURL=ProductCard.js.map
